/* unplugin-vue-components disabled */import { render } from "./play-list-head.vue?vue&type=template&id=045c6062&scoped=true&ts=true"
import script from "./play-list-head.vue?vue&type=script&lang=ts"
export * from "./play-list-head.vue?vue&type=script&lang=ts"

import "./play-list-head.vue?vue&type=style&index=0&id=045c6062&scoped=true&lang=css"

import exportComponent from "E:\\Workspaces\\VScode\\vue3+TS\\vue案例\\cloudMusicProject-master\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-045c6062"],['__file',"src/components/play-list-head/play-list-head.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "045c6062"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('045c6062', __exports__)) {
    console.log('reload')
    api.reload('045c6062', __exports__)
  }
  
  module.hot.accept("./play-list-head.vue?vue&type=template&id=045c6062&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('045c6062', render)
  })

}


export default __exports__